import { createContext, useContext } from 'react'

type TabsContextType = {
  activeTab: string;
  activationMode: 'manual' | 'automatic';
  rootId: string;
  setActiveTab: (tab: string) => void;
  tabAlignment: 'border-box' | 'content-box';
}

export const TabsContext = createContext<TabsContextType>({
  activationMode: 'automatic',
  activeTab: '',
  rootId: '',
  setActiveTab: () => {},
  tabAlignment: 'border-box',
})

export function useTabsContext () {
  return useContext(TabsContext)
}
